<template>

    <div>
        <link href="static/bootstrap.min.css" rel="stylesheet">
        <div class="backg">
            <el-menu  mode="horizontal" class="daohang">
                <el-menu-item index="2">
                    <router-link to="EntityList"><img src="../../assets/img/logo.png" style="height: 55px;"></router-link>
                </el-menu-item>

                
               
                

                 <!-- <el-menu-item  v-if="webW<745"  @click="goPhoneFooterMenu('SearchLeft')">
                    <el-input  placeholder="搜索" v-model="keywords">
                        <el-button slot="append" icon="el-icon-search" @click="goSearch"></el-button>
                    </el-input>
                </el-menu-item> -->

                <!-- <div v-if="webW<745" @click="goPhoneFooterMenu('SearchLeft')"  :class="'center hander '+(nowMenu=='SearchLeft'?'sel':'')"  >
                        <i class="fa fa-search"></i>
                        <p>搜索</p>
                    </div> -->
<!-- 
                <el-submenu style="float: right;" index="1"  v-if="webW>=745" >
                    <template slot="title" ><img :src="$store.state.faceimg" class="touxiang"></template>
                    <el-menu-item index="1-1" ><router-link :to="'Home?type=myforum&authorId='+lander.uid">我的主页</router-link></el-menu-item>
                    <el-menu-item index="1-1" v-if="lander.role=='100'"><router-link to="AdminType">后台管理</router-link></el-menu-item>
                    <el-menu-item index="1-2" v-if="lander.role=='50'"><router-link to="AdminForum">帖子管理</router-link></el-menu-item>
                    <el-menu-item index="1-3" @click="logoutHandle">退出登录</el-menu-item>
                </el-submenu> -->

                <!-- <el-menu-item  style="float: right;" index="1" @click="logoutHandle"  v-if="webW>=745" >
                   
                   <template slot="title"><i class="el-icon-right" style="font-size: 30px;"></i></template>
                </el-menu-item> -->

                 <el-submenu style="float: right;"  index="100"  v-if="webW>=745" >
                     <template slot="title" ><img :src="$store.state.faceimg" class="touxiang"></template>
                    <el-menu-item index="200-1" ><router-link :to="'Home?type=myforum&authorId='+lander.uid">我的主页</router-link></el-menu-item>
                    <el-menu-item index="200-2" v-if="lander.role=='100'"><router-link to="EntityList">后台管理</router-link></el-menu-item>
                    <el-menu-item index="200-3" v-if="lander.role=='50'"><router-link to="AdminForum">帖子管理</router-link></el-menu-item>
                    <el-menu-item index="200-4" > <router-link to="EditUinfo" >编辑资料</router-link></el-menu-item>
                    <el-menu-item index="200-5"  ><router-link to="UpUpass" >密码邮箱</router-link></el-menu-item>
                    <el-menu-item index="200-6" @click="logoutHandle" >退出登录</el-menu-item>

                </el-submenu>


            </el-menu>



            <keep-alive> <router-view></router-view></keep-alive>





        </div>


        <div v-if="webW<1000" class="phonefooter">
            <el-row>
                 <el-col :span="6">
                    <div @click="goPhoneFooterMenu('ForumLeft')"  :class="'center hander '+(nowMenu=='ForumLeft'?'sel':'')" >
                        <i class="fa fa-life-buoy"></i>
                        <p>关注/板块<span v-if="newForumReleasedTipAllBoo" class="xiaoxidian"></span></p>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="goPhoneFooterMenu('MyMessageLeft')" :class="'center hander '+(nowMenu=='MyMessageLeft'?'sel':'')" >
                        <i class="fa fa-bell"></i>
                        <p>消息<span v-if="totalNotReadNum" class="xiaoxidian"></span></p>
                    </div>
                    
                </el-col>
                <el-col :span="6">
                    <div @click="goPhoneFooterMenu('SearchLeft')"  :class="'center hander '+(nowMenu=='SearchLeft'?'sel':'')"  >
                        <i class="fa fa-search"></i>
                        <p>搜索</p>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="goPhoneFooterMenu('MySet')"  :class="'center hander '+(nowMenu=='MySet'?'sel':'')"  >
                        <i class="fa fa-user"></i>
                        <p>我的</p>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>


</template>

<script>

    import {logout, getWindowWidth, dealResult,messageSocketUrl} from '../../api/common'
    import {  myMessageNotReadNum} from '../../api';
    import PubSub from "pubsub-js";

export default {
    data() {
        return{
            lander:{},
            webW:1200,

            totalNotReadNum:0,
            hitNotReadNum:0,
            commentNotReadNum:0,
           atNotReadNum:0,

            keywords:'',

            nowMenu:'Forum',

            newForumReleasedTipAllBoo:false,

        }
    },
    methods: {
        goPhoneFooterMenu(t){
            this.nowMenu=t;
            this.$router.push(t);
        },
        goSearch(){
          this.$router.push("SearchUser?indexSearchKeywords="+this.keywords+"&indexSearchType=searchUser");
        },
        logoutHandle(){
            logout();
        },
        getmyMessageNotReadNum(){
            console.log("header-messagenum---")
            this.lander = JSON.parse(this.$store.state.logininfo);
            let o={
                uid:this.lander.uid,
                token:this.lander.token,
            }
            myMessageNotReadNum( o).then((res) => {
                dealResult(res.data);
                if (res.data.status == 1) {
                    this.totalNotReadNum=res.data.obj.totalNotRead;
                    this.hitNotReadNum=res.data.obj.hitNotRead;
                    this.commentNotReadNum=res.data.obj.commentNotRead;
                    this.atNotReadNum=res.data.obj.atNotRead;
                } else{

                }
            })
        },

        getMessageSocket() {

            let that = this;
            if ("WebSocket" in window) {

                console.log("您的浏览器支持 WebSocket!");

                that.ws = new WebSocket(messageSocketUrl+this.lander.uid);
                that.$messageSocket.setWs(that.ws);

                that.$messageSocket.ws.onopen = function() {
                    console.log("Socket 已打开");
                };

                that.$messageSocket.ws.onmessage = function(msg) {
                    console.log(msg.data)
                    let m=JSON.parse(msg.data);
                    if(m.type=='addForumTip'){
                        //右边小红点添加帖子提醒
                        PubSub.publish('newForumReleasedTip', m.forumObj );
                    }else{
                        that.$notify({
                            title: '你收到一条消息',
                            message: m.msg,
                            duration: 2000
                        });
                    }

                    //消息通知上面小红点出现
                    PubSub.publish('changeMyNotReadMessageNum', "1");
                };

                that.ws.onclose = function() {
                    // 关闭 websocket
                    console.log("连接已关闭...");
                    setTimeout(() => {
                        that.getMessageSocket();
                    }, 2000);
                };
            } else {
                this.$message.error("您的浏览器不支持 WebSocket!")
                // 浏览器不支持 WebSocket
                console.log("您的浏览器不支持 WebSocket!");
            }
        },


    },mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.webW=getWindowWidth();

        this.getmyMessageNotReadNum();
        this. getMessageSocket();


        PubSub.subscribe('changeMyNotReadMessageNum',(msg,index)=>{
            if(index=="1")this. getmyMessageNotReadNum();
        });

        //当其他人发布新帖，下面群组出现小红点
        PubSub.subscribe('newForumReleasedTipAll',(msg,boo)=>{
             this.newForumReleasedTipAllBoo=boo;
        });

    }
};
</script>

<style scoped>
    .touxiang{height: 45px;width:45px;border-radius: 50%;}
    .daohang{position: fixed;width: 100%;border-top: 2px solid #ff8200;z-index: 10;}
    .backg{background: #f5f5f5;min-height: 100vh;}

    .margintop{
        height: 70px;
    }

</style>
